export =
    [
        {
            "stroke": {
                "color": "blue",
                "width": 2
            }

        }
    ];